/**
 * Default wordlist for passphrases (~250 words → ~8 bits/word).
 *
 * Curated and short subset to keep bundle light. For maximum
 * entropy in production, inject full EFF list (7776 words →
 * 12.9 bits/word) via `generatePassphrase({ wordlist })`. Generator computes
 * entropy from actual list size, so replacing it is transparent.
 * seguro y transparente.
 */

export const DEFAULT_WORDLIST: readonly string[] = [
  "able",
  "acid",
  "acorn",
  "actor",
  "adapt",
  "adept",
  "adobe",
  "agile",
  "alarm",
  "album",
  "alert",
  "algae",
  "alibi",
  "alien",
  "alloy",
  "amber",
  "amend",
  "amino",
  "ample",
  "angle",
  "ankle",
  "apple",
  "april",
  "apron",
  "arbor",
  "arena",
  "argue",
  "arise",
  "armor",
  "arrow",
  "asset",
  "atlas",
  "atoll",
  "audio",
  "audit",
  "aunt",
  "aura",
  "avoid",
  "awake",
  "award",
  "azure",
  "bacon",
  "badge",
  "baker",
  "balmy",
  "banjo",
  "basil",
  "basin",
  "batch",
  "beach",
  "beard",
  "beast",
  "beech",
  "began",
  "begin",
  "belt",
  "bench",
  "berry",
  "bison",
  "black",
  "blade",
  "blaze",
  "bloom",
  "board",
  "boost",
  "booth",
  "brave",
  "bread",
  "brick",
  "brief",
  "brisk",
  "broom",
  "brush",
  "buddy",
  "bugle",
  "bunch",
  "cabin",
  "cable",
  "cacao",
  "cadet",
  "camel",
  "canal",
  "candy",
  "canoe",
  "canon",
  "cargo",
  "carol",
  "cedar",
  "chalk",
  "charm",
  "chase",
  "cheek",
  "chess",
  "chief",
  "chime",
  "civic",
  "clamp",
  "clasp",
  "clean",
  "cliff",
  "cloak",
  "clock",
  "cloud",
  "clove",
  "coach",
  "coast",
  "cobra",
  "cocoa",
  "comet",
  "coral",
  "corn",
  "cove",
  "crane",
  "crate",
  "creek",
  "crisp",
  "crown",
  "cube",
  "curve",
  "daisy",
  "dance",
  "dandy",
  "dawn",
  "delta",
  "denim",
  "depot",
  "diary",
  "dice",
  "diner",
  "ditch",
  "dizzy",
  "dodge",
  "donor",
  "dough",
  "dove",
  "draft",
  "drift",
  "drum",
  "dune",
  "eagle",
  "early",
  "earth",
  "easel",
  "ebony",
  "eddy",
  "elbow",
  "elder",
  "elite",
  "elm",
  "email",
  "ember",
  "emu",
  "epoch",
  "equal",
  "essay",
  "ether",
  "extra",
  "fable",
  "fairy",
  "fancy",
  "fauna",
  "fern",
  "ferry",
  "fever",
  "fiber",
  "field",
  "flame",
  "flare",
  "fleet",
  "flint",
  "float",
  "flock",
  "flora",
  "flour",
  "flute",
  "focal",
  "foggy",
  "forge",
  "fox",
  "frost",
  "fruit",
  "fudge",
  "gable",
  "gauge",
  "gecko",
  "genie",
  "ghost",
  "giant",
  "glade",
  "gleam",
  "globe",
  "glory",
  "glove",
  "grain",
  "grape",
  "grasp",
  "grid",
  "grove",
  "gulf",
  "gumbo",
  "gusto",
  "habit",
  "hazel",
  "heart",
  "hedge",
  "helm",
  "heron",
  "hippo",
  "hive",
  "hobby",
  "honey",
  "horse",
  "hotel",
  "hound",
  "hut",
  "ideal",
  "igloo",
  "index",
  "inlet",
  "ionic",
  "irony",
  "islet",
  "ivory",
  "jazz",
  "jelly",
  "jewel",
  "jolly",
  "joust",
  "juice",
  "jumbo",
  "kayak",
  "kettle",
  "kiln",
  "kiosk",
  "kite",
  "koala",
  "label",
  "lagoon",
  "lance",
  "larch",
  "lasso",
  "latch",
  "layer",
  "leaf",
  "ledge",
  "lemon",
  "lever",
  "lilac",
  "lily",
  "linen",
  "llama",
  "lobby",
  "locus",
  "lodge",
  "lotus",
  "lunar",
  "lyric",
  "macro",
  "magma",
  "mango",
];
